import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { imageworkupService } from 'app/EMR/Image_workup/Services/Imageworkup.services';
import { AuthService } from 'app/auth/auth.service';
import { BillingserviceService } from 'app/billing/billingService.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';

@Component({
  selector: 'app-email-ipd-files',
  templateUrl: './email-ipd-files.component.html',
  styleUrls: ['./email-ipd-files.component.scss']
})
export class EmailIpdFilesComponent implements OnInit {
  displayedColumns: string[] = ['filename', 'select'];
  dataSource: any = [];
  folderName: string;
  IPDid: any;
  constructor(public dialogRef: MatDialogRef<EmailIpdFilesComponent>, public billingService: BillingserviceService,
    public authService: AuthService, public opdvisitService: OpdVisitService,public imageWorkupService :imageworkupService) { }

  ngOnInit(): void {
    let branchid = this.authService.Loggeduser.branchid;
    if (this.opdvisitService.ipdId == 0) {
      this.IPDid = this.billingService.ipdID;
    } else {
      this.IPDid = this.opdvisitService.ipdId
    }
    this.folderName = 'IPDDocument';
    this.patIpdist(this.IPDid, branchid, this.folderName);
  }

  closedialog() {
    this.dialogRef.close();
  }

  patIpdist(ipdId, bid, fname) {
    this.imageWorkupService.getAzureImagedata(ipdId, bid, fname).subscribe((data:any) => {
      if(data.length >0){
        data.forEach(element => {
          this.dataSource.push({ filename: element.documentName, select: false,fileurl:element.documentURL });
        });
      }
      });
    // this.billingService.getIpdDoc(ipdId, bid, fname).subscribe(data => {
    //   let ipdDocdata = data;
    //   ipdDocdata.filter(doc => doc != null).forEach(element => {
    //     this.dataSource.push({ filename: element, select: false });
    //   });
    // });
  }

  onSelectClick() {
    this.billingService.ipdDocdata = [];
    let selectedData = this.dataSource.filter(x => x.select == true);
    selectedData.forEach(item => {
      this.billingService.ipdDocdata.push({filename:item.filename,fileurl:item.documentURL});
    });
    this.closedialog();
  }
}
